import EmailFormFooter from './EmailFormFooter';
export default EmailFormFooter;